import { TireWheelRatesQuery, useTireWheelRatesLazyQuery } from '../../../../gql/generated/graphql';

import CalcProductButton, { ProductButtonConfig } from './CalcProductButton';

import { PermissionEnum } from '../../../../constants/permissions';

const tireWheelConfig: ProductButtonConfig<TireWheelRatesQuery> = {
  permission: PermissionEnum.CalculateTireWheel,
  buttonText: 'CALC T&W',
  loadingText: 'CALC T&W',
  successMessage: 'Tire & Wheel rate retrieved successfully',
  errorMessage: 'Failed to retrieve Tire & Wheel rate',
  costField: 'tire_wheel_cost',
  priceField: 'tire_wheel_price',
  useRatesQuery: useTireWheelRatesLazyQuery,
  extractRate: (data) => data?.tireWheelRates?.[0]?.deductible ?? undefined,
};

const CalcTireWheelButton = ({ onRatesLoaded }: { onRatesLoaded?: () => void }) => (
  <CalcProductButton config={tireWheelConfig} onRatesLoaded={onRatesLoaded} />
);

export default CalcTireWheelButton;
